
let initialState = {
    product: null,
    model: null,
    design: null,
    finish: null,
    logo: null
};

function WrapSelectionReducer(state = initialState, action){
    switch (action.type) {
        case "SET_WRAP_SELECTION":
            return action.payload;

        default: return state;
    }
}

export default WrapSelectionReducer;
